import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import moment from 'moment';
import TimeLag from 'utilities/timelag';
import {
  Global,
  LineSelectedSchedule,
} from '../model';
import {
  PLANNER_OVER_SCHEDULE,
} from 'apps/events';
import PlannerControllerBase from './base';
export default class KeyboardController extends PlannerControllerBase {
  eventOnSelectSchedule: (e) => void;
  destroyLag: TimeLag;
  constructor(tag){
    super(tag);
    this.destroyLag = new TimeLag((params) => { this.destroyDo(params); }, 100)
    this.reduxEvent('planner.orders_planner.selectedSchedule', (newVal, oldVal, objectPath) => {
      this.onSelectSchedule(newVal, oldVal, objectPath);
    });
  }
  onSelectSchedule(selectedSchedule: LineSelectedSchedule, oldVal, objectPath){
    if(selectedSchedule){
      this.setEventOnSelectSchedule(selectedSchedule);
    }else{
      this.unsetEventOnSelectSchedule();
    }
  }
  setEventOnSelectSchedule(selectedSchedule: LineSelectedSchedule){
    this.unsetEventOnSelectSchedule();
    this.eventOnSelectSchedule = (e) => { this.onKeyDownOnSelectSchedule(e) };
    document.addEventListener('keyup', this.eventOnSelectSchedule);
  }
  unsetEventOnSelectSchedule(){
    if(!this.eventOnSelectSchedule){ return; }
    document.removeEventListener('keyup', this.eventOnSelectSchedule);
    this.eventOnSelectSchedule = undefined;
  }
  onKeyDownOnSelectSchedule(e){
    if(e.key === 'Backspace' || e.key === 'Delete'){
      let tagName = document.activeElement.nodeName;
      if(tagName == 'INPUT') { return; }
      if(tagName == 'TEXTAREA') { return; }
      this.removeSelectedSchedule();
    }
  }
  removeSelectedSchedule(){
    let selectedSchedule: LineSelectedSchedule = Global.getPlannerData().selectedSchedule;
    let baseAction = Global.getFormScheduleDestroyData().base_action;
    if(!selectedSchedule) { return; }
    this.unsetEventOnSelectSchedule();
    let schedules = Global.getLineData(selectedSchedule.lineId).schedules;
    if(!schedules){ schedules = []; }
    schedules = schedules.filter(id => id !== selectedSchedule.scheduleId);
    let newVal = {};
    let lineId = Global.dataScopeLine(selectedSchedule.lineId);
    newVal[lineId] = { schedules: null }
    this.updateLines(newVal);
    this.updatePlanner({
      orders_planner: {
        selectedSchedule: null,
        selectedTask: null,
        removeSchedule: selectedSchedule,
        selectedTasksMemo: null
      },
    });
    newVal[lineId] = { schedules: schedules }
    this.updateLines(newVal);
    this.destroyLag.start({action: baseAction.replace('0', selectedSchedule.scheduleId)})
  }
  destroyDo(params){
    this.updateData({
      black_over: {
        show: false
      },
      forms_schedules_destroy: {
        action: params.action,
      }
    });
  }
}
